import { HTMLAttributes } from "react"

export default function NuxtJS(props: HTMLAttributes<SVGElement>) {
  return (
    <svg
      {...props}
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.7252 40.8638L14.6187 40.6511C14.4061 40.2255 14.4061 39.7999 14.5126 39.2678H3.02218L20.0453 9.05175L27.174 21.9255L29.5144 20.223L22.3857 7.34925C22.2796 7.13662 21.4283 5.86012 20.0453 5.86012C19.4067 5.86012 18.4493 6.07275 17.7046 7.45612L0.4688 37.9913C0.3623 38.31 -0.38245 39.6938 0.2558 40.8638C0.681425 41.502 1.31967 42.1406 2.80955 42.1406H17.2793C15.7894 42.1406 15.0447 41.502 14.7256 40.8638H14.7252ZM47.4946 38.0974L33.6634 13.2011C33.4508 12.9881 32.7057 11.6047 31.3227 11.6047C30.6844 11.6047 29.7267 11.9243 28.9819 13.2008L27.1733 16.1798V21.9251L31.3227 14.7964L45.0477 39.2674H39.834C39.9214 39.774 39.847 40.2953 39.6214 40.7572L39.5149 40.8634C38.8767 42.0338 37.2807 42.1403 37.0677 42.1403H45.1538C45.4729 42.1403 46.9624 42.0338 47.7076 40.8634C48.0263 40.3316 48.2393 39.3739 47.4946 38.0974ZM39.9406 40.8638V40.7572L40.0471 40.5446C40.1532 40.119 40.2597 39.6934 40.1532 39.2678L39.7279 37.9913L28.875 19.053L27.2794 16.1805H27.1729L25.5769 19.053L14.7248 37.9913L14.2992 39.2678C14.1962 39.8088 14.2709 40.3686 14.5122 40.8638C14.9378 41.502 15.576 42.1406 17.0659 42.1406H37.2807C37.5998 42.1406 39.1958 42.0341 39.9406 40.8638ZM27.1733 21.9255L37.0681 39.2678H17.2786L27.1733 21.9255Z"
        fill="#34E083"
      />
    </svg>
  )
}
